"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getCustomLinkParam", {
    enumerable: true,
    get: function() {
        return getCustomLinkParam;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const getCustomLinkParam = async (_context, { col }, _ncMeta = _Noco.default.ncMeta)=>{
    if (!(0, _nocodbsdk.parseProp)(col.meta).custom) {
        return;
    }
};
